<template>
<div class="chapter">
<div class="inner_page">
<p class="centerImage1"><a id="page_8"></a><img alt="images" src="images/map1.jpg"/></p>
<p class="caption">Just some of the places we visited - often only seeing the airports!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_fm01.vue?f0be700a